import { Settings } from "@mui/icons-material";
import { AppBar, Stack, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTodos } from "../Todo/context/TodoContext/TodoContext";
import { HeaderButton, HeaderIconButton, LogoButton } from "./component/Components";
import LoginButton from "./component/LoginButton";
import ThemeToggle from "./component/ThemeToggle";

const Header = () => {
    const navigate = useNavigate();
    const { currentWorkspace } = useTodos();

    return (
        <AppBar
            position="static"
            sx={{
                bgcolor: 'background.paper',
                color: 'text.secondary',
                boxShadow: 'none',
                borderBottom: '1px solid rgba(75, 85, 99, 0.12)'
            }}
        >
            <Toolbar sx={{ px: '12px' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" columnGap={2} rowGap={0.5} width={1} flexWrap="wrap">
                    <Stack direction="row" alignItems="center" columnGap={2} rowGap={0.5} flexWrap="wrap">
                        <LogoButton />
                        <Stack direction="row" gap={0.5} flexWrap="wrap">
                            <HeaderButton to="workspace">Workspace <Typography component="span" color="inherit" ml={0.5}>{currentWorkspace?.title ? `(${currentWorkspace?.title})` : ''}</Typography></HeaderButton>
                            <HeaderButton to="todo">TODO</HeaderButton>
                            <HeaderButton to="calendar">Calendar</HeaderButton>
                            {/* <HeaderButton to="map">Map</HeaderButton> */}
                        </Stack>
                    </Stack>
                    <Stack direction="row" flexShrink={0} gap={0.5} flexWrap="wrap">
                        {/* <HeaderIconButton>
                            <Search />
                        </HeaderIconButton>
                        <HeaderIconButton>
                            <NotificationsNone />
                        </HeaderIconButton>
                        <HeaderIconButton>
                            <HelpOutline />
                        </HeaderIconButton> */}
                        <ThemeToggle />
                        <HeaderIconButton onClick={() => navigate('/settings')}>
                            <Settings />
                        </HeaderIconButton>
                        <LoginButton />
                    </Stack>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Header;